import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import LoadingIndicator from "../../components/loading-indicator";

const LevelsDataGrid = lazy(() =>
    import("../../components/levels-data-grid")
);

export default function PuzzlesPage() {
    const { t } = useTranslation();

    return (
        <>
            <h2 className="mb-4">{t("puzzles")}</h2>
            <Suspense fallback={<LoadingIndicator />}>
                <LevelsDataGrid />
            </Suspense>
        </>
    );
}